import eventSaga from "../modules/event/saga";

export default [eventSaga];
